//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ProfessionalInfoClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetProfessionalInfoQueryParameters = {
  device?: Types.DeviceBrand | null | undefined ;
  title?: string | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export function getUrl(device?: Types.DeviceBrand | null | undefined, title?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/professional-info?";
if (device !== undefined && device !== null)
    url_ += "Device=" + encodeURIComponent("" + device) + "&";
if (title !== undefined && title !== null)
    url_ += "Title=" + encodeURIComponent("" + title) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.ProfessionalInfoResponseDto, unknown, Types.ProfessionalInfoResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ProfessionalInfoResponseDto, unknown, Types.ProfessionalInfoResponseDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetProfessionalInfoQueryParameters): QueryKey;
export function getQueryKey(device?: Types.DeviceBrand | null | undefined, title?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { device, title, offset, limit, sortBy, sortOrder,  } = params[0] as GetProfessionalInfoQueryParameters;

    return trimArrayEnd([
        'ProfessionalInfoClient',
        'get',
        device as any,
        title as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'ProfessionalInfoClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as Types.DeviceBrand | null | undefined,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as Types.SortOrder | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.ProfessionalInfoResponseDto, TError = unknown>(dto: GetProfessionalInfoQueryParameters, options?: Omit<UseQueryOptions<Types.ProfessionalInfoResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data.
 * @param device (optional) 
 * @param title (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetQuery<TSelectData = Types.ProfessionalInfoResponseDto, TError = unknown>(device?: Types.DeviceBrand | null | undefined, title?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.ProfessionalInfoResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.ProfessionalInfoResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ProfessionalInfoResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let device: any = undefined;
  let title: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ device, title, offset, limit, sortBy, sortOrder,  } = params[0] as GetProfessionalInfoQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [device, title, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ProfessionalInfoResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(device, title, offset, limit, sortBy, sortOrder),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.ProfessionalInfoResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data.
 * @param device (optional) 
 * @param title (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.ProfessionalInfoResponseDto | undefined) => Types.ProfessionalInfoResponseDto, device?: Types.DeviceBrand | null | undefined, title?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getQueryKey(device, title, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets data.
 * @param device (optional) 
 * @param title (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ProfessionalInfoResponseDto | undefined) => Types.ProfessionalInfoResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}